import { useCallback, useEffect, useLayoutEffect, useRef } from 'react'

export default function useKeyPress(keys: string[], callback: () => void) {
  const callbackRef = useRef(callback)
  useLayoutEffect(() => {
    callbackRef.current = callback
  })

  const handleKeyPress = useCallback(
    (event: KeyboardEvent) => {
      if (keys.some((key) => event.key.toLowerCase() === key)) {
        if (event.shiftKey === true) {
          callbackRef.current()
        }
      }
      return event
    },
    [keys],
  )

  useEffect(() => {
    document.addEventListener('keydown', handleKeyPress)
    return () => document.removeEventListener('keydown', handleKeyPress)
  }, [handleKeyPress])
}
